export default "__VITE_ASSET__DrjpAaz$__"